import { EventListCardData } from '../../event/event-types';

export const isOnDemandEvent = (event?: EventListCardData) => {
    if (!event) {
        return false;
    }

    // Only use explicit isOnDemand flag - eventExpireDate is for auto-hiding,
    // not for determining if event is on-demand (in-person events can have expire dates too).
    // The flag is gated to goto events at the WordPress headless layer
    // (see services/wordpress/src/wp-content/themes/rawb/single-event.php).
    return event?.isOnDemand === true;
};
